import { render, staticRenderFns } from "./TaxonomyProducts.vue?vue&type=template&id=90f76aa4&"
import script from "./TaxonomyProducts.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports